import React, { useState, useEffect } from 'react'
import { func, object, bool } from 'prop-types'
import './dox_explorer.scss'
import { TranslationContextProvider } from '../Shared/hooks/useTranslationContextHook'
import { UnauthorizedContextProvider } from '../Shared/hooks/useUnauthorizedContextHook'
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook'
import DoxModal from '../Shared/components/doxModal'
import DoxExplorerMainTaxYears from './components/doxExplorerMainTaxYears'
import DoxExplorerMainFiles from './components/doxExplorerMainFiles'
import { useDoxExplorerParent } from '../../../../../hooks/useDoxExplorerParentHook';

const DoxExplorer = (props) => {
    const [, , , primaryName,] = useInterviewInfo(props.ticket);
    const [translateString, handleUnauthorized] = useDoxExplorerParent();

    const [ticketId, setTicketId] = useState(0)
    const [taxYear, setTaxYear] = useState(null)

    const layoutType = 'desktop'

    useEffect(() => {
        if (props.ticket) {
            if (taxYear) {
                if (taxYear === props.ticket.taxYear) {
                    if (ticketId !== props.ticket.id) {
                        setTicketId(props.ticket.id)
                    }
                } else {
                    let rt = props.ticket.relatedTickets.find(x => x.taxYear === taxYear)
                    if (rt.ticketId !== ticketId) {
                        setTicketId(rt.ticketId)
                    }
                }
            } else {
                setTicketId(0)
            }
        }
    }, [props.ticket, taxYear, setTicketId, ticketId])

    useEffect(() => {
        if (!taxYear && taxYear !== props.ticket.taxYear) {
            setTaxYear(props.ticket.taxYear)
            setTicketId(props.ticket.id)
        }
    }, [props.ticket])

    useEffect(() => {

    }, [props.ticket])

    const handleSetTaxYear = (tax_year) => {
        if (tax_year !== taxYear) {
            setTaxYear(tax_year)
        }
    }

    return (
        <UnauthorizedContextProvider onHandleUnauthorizedUser={handleUnauthorized}>
            <TranslationContextProvider onTranslateString={translateString}>
                <DoxModal titleKey='Dox.DocumentExplorer.Title' titleKeyParams={{ TaxYear: taxYear, ClientName: primaryName }} show={props.show} onClose={props.onClose}>
                    {!taxYear && props.ticket &&
                        <DoxExplorerMainTaxYears layoutType={layoutType} ticket={props.ticket} onSetTaxYear={handleSetTaxYear} />
                    }
                    {taxYear && Number(ticketId) > 0 &&
                        <DoxExplorerMainFiles layoutType={layoutType} ticketId={ticketId} taxYear={taxYear}
                            onSetTaxYear={handleSetTaxYear} targetName={primaryName}/>
                    }                    
                </DoxModal>
            </TranslationContextProvider>
        </UnauthorizedContextProvider>
    )
}

DoxExplorer.propTypes = {
    ticket: object.isRequired,
    onClose: func.isRequired,
    show: bool.isRequired
}

export default DoxExplorer;